import * as core from '../../../../../../../core'

import { query } from './trends.query'

export const RESOURCE = {
  payload: {
    alias: 'rp:trends',
    content: {
      root: {
        elements: [
          {
            content: {
              widget: {
                widget: {
                  alias: 'rp.trends.widgets.stacked-bar-chart',
                },
              },
            },
            height: 400,
          },
          {
            content: {
              widget: {
                widget: {
                  alias: 'rp.trends.organization-trends-table',
                },
              },
            },
            height: 400,
          },
        ],
      },
    },
    description: 'Research Performance Trends Page',
    name: 'rp.trends',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
